import { CorporateActionTypes } from "./constants";

export interface CorporateActionType {
  type:
    | CorporateActionTypes.API_RESPONSE_SUCCESS
    | CorporateActionTypes.API_RESPONSE_ERROR
    | CorporateActionTypes.GET_CORPORATES
    | CorporateActionTypes.UPDATE_CORPORATES
    | CorporateActionTypes.ADD_CORPORATES
    | CorporateActionTypes.DELETE_CORPORATES
    | CorporateActionTypes.CLEAR_ERROR;

  payload: {} | string;
}

// common success
export const CorporateApiResponseSuccess = (actionType: string, data: any | {}): CorporateActionType => ({
  type: CorporateActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// common error
export const CorporateApiResponseError = (actionType: string, error: string): CorporateActionType => ({
  type: CorporateActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// get corporates
export const getCorporates = (status?: string, page?: number, limit?: number): CorporateActionType => ({
  type: CorporateActionTypes.GET_CORPORATES,
  payload: { status, page, limit },
});

export const deleteCorporates = (id: string): CorporateActionType => ({
  type: CorporateActionTypes.DELETE_CORPORATES,
  payload: {
    id,
  },
});

export const updateCorporate = (
  id: string,
  name: string,
  email: string,
  phone: string,
  address: string,
  is_active: boolean,
  code: any
): CorporateActionType => ({
  type: CorporateActionTypes.UPDATE_CORPORATES,
  payload: { id, name, email, phone, address, is_active, code },
});

// add Device
export const addCorporate = (name: string, email: string, phone: string, address: string, is_active: boolean, code: any): CorporateActionType => ({
  type: CorporateActionTypes.ADD_CORPORATES,
  payload: { name, email, phone, address, is_active, code },
});

// clear error
export const clearCorporateError = (): CorporateActionType => ({
  type: CorporateActionTypes.CLEAR_ERROR,
  payload: {},
});
